import styled from 'styled-components'

export const WrapperTableItem = styled.section`
  flex: 1;
  width: 100%;
  padding: 0 20px;
  pointer-events: all;
`
